module.exports = __webpack_public_path__ + "img/DieSteineGehorchenMir.d9f665c8.jpg";